import { isAbortError } from "./api-error";

function httpStatusOf(error: unknown): number | undefined {
  if (error && typeof error === "object" && "status" in error) {
    const status = (error as { status?: unknown }).status;
    if (typeof status === "number" && Number.isFinite(status)) return status;
  }
  return undefined;
}

/**
 * The single React-Query retry contract for Louise API queries. The decision
 * lives here, not on the error: the error only carries an HTTP `status` (which
 * `ApiRequestError` does). Client errors (4xx, except 408/429) are
 * unrecoverable and stop immediately; server errors, throttling, and network
 * failures (no status) retry up to twice.
 */
export function retryLouiseQuery(failureCount: number, error: unknown) {
  if (isAbortError(error)) return false;

  const status = httpStatusOf(error);
  if (
    status !== undefined &&
    status >= 400 &&
    status < 500 &&
    status !== 408 &&
    status !== 429
  ) {
    return false;
  }
  return failureCount < 2;
}
